import React from "react";

import { StyledSVG } from "../StyledIcon";

export const StandardIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M9.00118 15.5996L16.2758 5.84961L13.2758 2.39961H4.72656L1.72656 5.84961L9.00118 15.5996Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.80078 2.40039L5.02404 5.85039L9.00078 15.3004L12.9775 5.85039L13.2008 2.40039"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.80078 5.84961H16.2008"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
